import { getCookie } from "cookies-next";
import { ApiConfig } from "~/api-client";
import { create as createGraphql } from "~/graphql-client";
import { Ordering } from "../OrderingService";
import { CoordsInput } from "~/graphql-client/generated";

export class ApiOrderingService {
  constructor(private apiConfig: ApiConfig) {}

  async fetch(locationRef: string, to?: CoordsInput): Promise<Ordering | null> {
    const graphql = createGraphql(
      this.apiConfig,
      () => getCookie("token") as string,
    );

    const data = await graphql.getOrdering(locationRef, to);

    if (!data.ordering) {
      return null;
    }

    const {
      deliveryConfig = null,
      pickupConfig = null,
      serviceConfig = null,
    } = data.ordering;

    return {
      deliveryConfig: deliveryConfig
        ? {
            ...deliveryConfig,
            externalPaymentEnabled:
              deliveryConfig.externalPaymentEnabled || false,
            timeSlots: deliveryConfig.timeSlots || null,
          }
        : null,
      pickupConfig: pickupConfig
        ? {
            ...pickupConfig,
            timeSlots: pickupConfig.timeSlots || null,
            active: pickupConfig.active || false,
            waitTime: pickupConfig.waitTime || 0,
            allowItemNotes: pickupConfig.allowItemNotes || false,
            allowOrderNotes: pickupConfig.allowOrderNotes || false,
            tipsEnabled: pickupConfig.tipsEnabled || false,
            tipRatios: pickupConfig.tipRatios || [],
            externalPaymentEnabled:
              pickupConfig.externalPaymentEnabled || false,
          }
        : null,
      serviceConfig: serviceConfig
        ? {
            ...serviceConfig,
            active: serviceConfig.active || false,
            waitTime: serviceConfig.waitTime || 0,
            validRefs: serviceConfig.validRefs || null,
            serviceChargeLabel: serviceConfig.serviceChargeLabel || null,
            serviceChargeRate: serviceConfig.serviceChargeRate || null,
            allowItemNotes: serviceConfig.allowItemNotes || false,
            allowOrderNotes: serviceConfig.allowOrderNotes || false,
            tipsEnabled: serviceConfig.tipsEnabled || false,
            tipRatios: serviceConfig.tipRatios || [],
            externalPaymentEnabled:
              serviceConfig.externalPaymentEnabled || false,
          }
        : null,
    };
  }
}
